$(document).ready(function () {

    $('.sidebar').find('li').removeClass('active');
    $('.sidebar').find('li.careerlink ').addClass('active');

    var discoveroppurtunities = new Swiper('.js-discover-oppurtunities', {
        // loop: true,
        slidesPerView: 1,
        breakpoints: {
            320: {
                slidesPerView: 1.5,
                // spaceBetween: 25,
                // loop: true,
            },

            414: {
                slidesPerView: 1,
                // spaceBetween: 25,
                // loop: true,
            },

            769: {
                slidesPerView: 1,
                // loop: true,
            },
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
        }

    });

    // Mobile-slider

    (function () {
        "use strict";
        const breakpoint = window.matchMedia("(min-width:40.25em)");

        // keep track of swiper instances to destroy later
        let mySwiper;

        const breakpointChecker = function () {
            // if larger viewport and multi-row layout needed
            if (breakpoint.matches === true) {
                // clean up old instances and inline styles when available
                if (mySwiper !== undefined) mySwiper.destroy(true, true);

                // or/and do nothing
                return;

                // else if a small viewport and single column layout needed
            } else if (breakpoint.matches === false) {
                // fire small viewport version of swiper
                return enableSwiper();
            }
        };

        const enableSwiper = function () {
            mySwiper = new Swiper(".js-resp-inspired", {
                loop: false,
                slidesPerView: 1.3,
                // a11y: true,
                keyboardControl: true,
                grabCursor: true,

                // pagination
                pagination: ".swiper-pagination",
                paginationClickable: true,
            });
        };

        // keep an eye on viewport size changes
        breakpoint.addListener(breakpointChecker);

        // kickstart
        breakpointChecker();
    })(); /* IIFE end */

})